<div class="card h-100 text-center event-card">
  <a [routerLink]="[event.slug]" class="card-body p-4 event-link h-100 ">
    <h5 class="card-title">{{ event.name }}</h5>
    <h6 class="card-subtitle mb-2 text-muted">
      {{ date }}
    </h6>

    <p class="card-text">
      <span *ngIf="event.venue && event.venue.city && event.venue.state">
        {{ event.venue.city }},
        {{ event.venue.state }}
      </span>
    </p>
  </a>
</div>
